import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si nunca tuve un péndulo ni sé nada de radiestesia?',
    a: 'Especialmente para vos. El sistema arranca desde cero absoluto — desde qué péndulo elegir hasta cómo cobrar tu primera consulta. No necesitás experiencia previa de ningún tipo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el Kit en tu dispositivo.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No. Está optimizado para usarse en tablet, computadora o celular. Si preferís imprimirlo, el formato A4 es perfecto para eso.'
  }, {
    q: '¿Qué lo diferencia de lo que puedo aprender gratis en YouTube?',
    a: 'Los videos sueltos no tienen sistema, no tienen fichas de cliente, no tienen protocolo de consulta y no te enseñan a cobrar ni a fabricar. Este Kit es un método completo, ordenado y con un único objetivo: que emprendas y generes ingresos reales desde casa.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días. Si no te convence, te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Puedo compartirlo con otras personas?',
    a: 'El Kit es de uso personal. Está prohibida su reproducción y redistribución sin autorización expresa de Lumen Akasha™.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-76">
      <div className="text-center mb-12" data-id="element-77">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-plum" data-id="element-78">
          <span className="mr-3" data-id="element-79">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-80">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-gold/25 bg-brand-surfaceLight/80" data-id="element-81">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surface/60 transition-colors" data-id="element-82">
              <span className="font-medium pr-8 text-brand-plum text-[14px]" data-id="element-83">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-84" />
            </button>
            <AnimatePresence data-id="element-85">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-86">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-gold/20 pt-4 bg-brand-surfaceLight/60 text-[13px] leading-relaxed" data-id="element-87">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};